import React, {Component} from 'react';
import '../styles/Thread.css';
import { getPages } from '../services/pagesService';
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Pagination,
  Chip,
  Tooltip,
  Link as MuiLink,
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  ToggleButton,
  ToggleButtonGroup,
  IconButton
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LabelIcon from '@mui/icons-material/Label';
import PublicIcon from '@mui/icons-material/Public';
import LinkIcon from '@mui/icons-material/Link';
import ArticleIcon from '@mui/icons-material/Article';
import TableChartIcon from '@mui/icons-material/TableChart';
import ViewModuleIcon from '@mui/icons-material/ViewModule';

class Pagesgd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hits: [],
      page: 1,
      total_elem: 0,
      isLoading: false,
      q: '',
      viewMode: 'card' // 'card' | 'table'
    };
    this.onSearchSubmit = this.onSearchSubmit.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.fetchPage = this.fetchPage.bind(this);
    this.handleViewModeChange = this.handleViewModeChange.bind(this);
    this.renderPageCard = this.renderPageCard.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchPage(1, '');
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onSearchSubmit(e) {
    e.preventDefault();
    this.fetchPage(1, this.state.q);
  }

  onPageChange(e, value) {
    this.fetchPage(value, this.state.q);
  }

  fetchPage(page, q) {
    this.setState({ isLoading: true });
    getPages(q || '', page)
      .then((result) => {
        if (!this._isMounted) return;
        const total = parseFloat(result.total_elem_pending + result.total_elem_approved + result.total_elem_deleted) || 0;
        this.setState({
          hits: result.pages || [],
          page: parseFloat(result.page_nbr) || page,
          total_elem: total,
          isLoading: false
        });
      })
      .catch(() => this.setState({ isLoading: false }));
  }

  handleViewModeChange(e, nextView) {
    if (nextView) this.setState({ viewMode: nextView });
  }

  renderPageCard(item) {
    const tagsText = (item.tags || []).map(t => t.content).join(', ');
    return (
      <Card key={item._id} variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          avatar={<ArticleIcon color="primary" />}
          title={
            <Tooltip title={item.subject || ''}>
              <Typography variant="subtitle1" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {item.subject || '(sans sujet)'}
              </Typography>
            </Tooltip>
          }
          subheader={
            <Stack direction="row" spacing={1} alignItems="center" sx={{ flexWrap: 'wrap' }}>
              <Chip size="small" label={item.status} color={item.status === 'approved' ? 'success' : item.status === 'pending' ? 'warning' : 'default'} />
              <Stack direction="row" spacing={1} alignItems="center">
                <PublicIcon fontSize="small" />
                <MuiLink component={RouterLink} to={`/super-admin/website/?website_id=${item.website?._id}`} underline="hover">
                  {item.website?._id}
                </MuiLink>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ pt: 0, flex: 1 }}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1, flexWrap: 'wrap' }}>
            <LinkIcon fontSize="small" />
            <Tooltip title={item.slug || ''}>
              <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {item.slug}
              </Typography>
            </Tooltip>
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1, flexWrap: 'wrap' }}>
            <CalendarTodayIcon fontSize="small" />
            <Typography variant="body2">{item.created_at}</Typography>
          </Stack>

          <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap' }}>
            <LabelIcon fontSize="small" sx={{ mr: 0.5 }} />
            {((item.tags || []).slice(0, 3)).map((t) => (
              <Chip key={t.content} size="small" label={t.content} />
            ))}
            {(item.tags || []).length > 3 && <Chip size="small" label={`+${(item.tags || []).length - 3}`} />}
          </Stack>
        </CardContent>
        <CardActions sx={{ pt: 0, justifyContent: 'flex-end' }}>
          <IconButton
            aria-label="Ouvrir le sujet"
            component="a"
            href={`${item.website?.url}/t/${item.slug}`}
            target="_blank"
            rel="noopener"
          >
            <OpenInNewIcon />
          </IconButton>
        </CardActions>
      </Card>
    );
  }

  render() {
    const { hits, page, total_elem, isLoading, q } = this.state;
    const pageCount = Math.max(1, Math.ceil((total_elem || 0) / 10));

    return (
      <Box sx={{ p: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
          <Typography variant="h6">Sujets GD</Typography>
          <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%', justifyContent: { xs: 'space-between', sm: 'flex-end' } }}>
            <Box component="form" onSubmit={this.onSearchSubmit} sx={{ display: 'flex', gap: 1, width: { xs: '100%', sm: 'auto' } }}>
              <TextField
                size="small"
                placeholder="Rechercher…"
                value={q}
                onChange={(e) => this.setState({ q: e.target.value })}
                sx={{ minWidth: { xs: '100%', sm: 280 } }}
              />
              <Button variant="contained" type="submit">Search</Button>
            </Box>
            <ToggleButtonGroup
              exclusive
              size="small"
              value={this.state.viewMode}
              onChange={this.handleViewModeChange}
            >
              <ToggleButton value="card" aria-label="Vue cartes"><ViewModuleIcon fontSize="small" /></ToggleButton>
              <ToggleButton value="table" aria-label="Vue tableau"><TableChartIcon fontSize="small" /></ToggleButton>
            </ToggleButtonGroup>
          </Stack>
        </Stack>

        {this.state.viewMode === 'card' ? (
          <>
            <Grid container spacing={2}>
              {hits.map((item) => (
                <Grid key={item._id} item xs={12} sm={6} md={4} lg={3}>
                  {this.renderPageCard(item)}
                </Grid>
              ))}
            </Grid>

            <Box sx={{ px: 1.5, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="caption" color="text.secondary">Page {page} / {pageCount}</Typography>
              <Pagination
                page={page}
                count={pageCount}
                onChange={this.onPageChange}
                size="small"
                color="primary"
                showFirstButton
                showLastButton
                siblingCount={0}
                boundaryCount={1}
              />
            </Box>
          </>
        ) : (
          <Paper variant="outlined">
            <TableContainer sx={{ maxHeight: '70vh' }}>
              <Table size="small" stickyHeader sx={{ '& tbody tr:nth-of-type(odd)': { bgcolor: 'action.hover' }, tableLayout: 'fixed' }}>
                <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Subject</TableCell>
                  <TableCell>Slug</TableCell>
                  <TableCell>Website</TableCell>
                  <TableCell>Internal Id</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Tags</TableCell>
                  <TableCell>Voir sujet</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && hits.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center">Chargement…</TableCell>
                  </TableRow>
                ) : (
                  hits.map((item) => (
                    <TableRow key={item._id} hover>
                      <TableCell sx={{ maxWidth: 220 }}>
                        <Tooltip title={item._id}>
                          <Typography variant="body2" sx={{ fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {item._id}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Chip size="small" label={item.status} color={item.status === 'approved' ? 'success' : item.status === 'pending' ? 'warning' : 'default'} />
                      </TableCell>
                      <TableCell sx={{ maxWidth: 280 }}>
                        <Tooltip title={item.subject || ''}>
                          <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {item.subject}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={{ maxWidth: 200 }}>
                        <Tooltip title={item.slug || ''}>
                          <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {item.slug}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={{ maxWidth: 220 }}>
                        <MuiLink component={RouterLink} to={`/super-admin/website/?website_id=${item.website?._id}`} underline="hover">
                          {item.website?._id}
                        </MuiLink>
                      </TableCell>
                      <TableCell sx={{ maxWidth: 140 }}>{item.id}</TableCell>
                      <TableCell sx={{ maxWidth: 180 }}>{item.created_at}</TableCell>
                      <TableCell sx={{ maxWidth: 320 }}>
                        <Tooltip title={(item.tags || []).map(t => t.content).join(', ')}>
                          <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {(item.tags || []).map(t => t.content).join(', ')}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <MuiLink href={`${item.website?.url}/t/${item.slug}`} target="_blank" rel="noopener" underline="hover">Ouvrir</MuiLink>
                      </TableCell>
                    </TableRow>
                  ))
                )}
                {!isLoading && hits.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <Typography variant="body2" color="text.secondary">Aucune donnée</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="caption" color="text.secondary">Page {page} / {pageCount}</Typography>
            <Pagination
              page={page}
              count={pageCount}
              onChange={this.onPageChange}
              size="small"
              color="primary"
              showFirstButton
              showLastButton
              siblingCount={0}
              boundaryCount={1}
            />
          </Box>
        </Paper>
        )}
      </Box>
    );
  }
}

export default Pagesgd;